import React from 'react';
import { SparklesIcon, AlertTriangleIcon, LightbulbIcon } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';
import type { AiTip } from '../../utils/aiAssist';
interface AiTipsProps {
  tips: AiTip[];
  /** Id of the tip currently highlighting the content, if any. */
  activeTipId: string | null;
  onSelect: (tip: AiTip) => void;
}

/** Advisory notes shown under a channel's content. They never block sending. */
export function AiTips({
  tips,
  activeTipId,
  onSelect
}: AiTipsProps) {
  const {
    t,
    lang
  } = useLanguage();
  if (tips.length === 0) return null;
  return <div className="rounded-lg border border-indigo-100 bg-indigo-50/40 p-3" data-id="element-3628" data-mp="27zbd0senly1z">
      <p className="flex items-center gap-1.5 text-[11px] font-bold text-[#4F46E5] uppercase tracking-wider mb-2" data-id="element-3629" data-mp="2cqjm1nc2nhem">
        <SparklesIcon className="w-3.5 h-3.5" data-id="element-3630" data-mp="1fbntzht17fhg" />
        {t('Recommandation ATNA', 'ATNA recommendation')}
      </p>
      <ul className="space-y-1" data-id="element-3631" data-mp="1k9772edztm7t">
        {tips.map(tip => {
        const Icon = tip.level === 'warning' ? AlertTriangleIcon : LightbulbIcon;
        const active = activeTipId === tip.id;
        const clickable = Boolean(tip.highlight);
        return <li key={tip.id} data-id="element-3632" data-mp="1rlknpufycf0h">
              <button type="button" onClick={() => onSelect(tip)} disabled={!clickable} title={clickable ? t('Mettre en évidence le passage concerné', 'Highlight the related text') : undefined} className={`w-full flex items-start gap-2 text-left px-2 py-1.5 rounded-md transition-colors ${active ? 'bg-white ring-1 ring-[#4F46E5]' : clickable ? 'hover:bg-white/70 cursor-pointer' : 'cursor-default'}`} data-id="element-3633" data-mp="1rkrd2idvh5d2">
                <Icon className={`w-3.5 h-3.5 mt-0.5 flex-shrink-0 ${tip.level === 'warning' ? 'text-amber-500' : 'text-[#4F46E5]'}`} data-id="element-3634" data-mp="wcz7v93i6mct" />
                <span className="text-xs text-slate-600 leading-snug" data-id="element-3635" data-mp="nckjg0v8sr53">
                  {tip.message[lang]}
                  {clickable && <span className="ml-1.5 text-[10px] font-semibold text-[#4F46E5] underline" data-id="element-3636" data-mp="rdw0hi01w41o">
                      {active ? t('mis en évidence', 'highlighted') : t('voir', 'show')}
                    </span>}
                </span>
              </button>
            </li>;
      })}
      </ul>
    </div>;
}